import { 
  PaymentData, 
  PaymentAllocation, 
  PaymentDeduction, 
  PaymentAttachment, 
  PaymentApprovalHistoryItem,
  PaymentStatus, 
  PaymentType, 
  PaymentMethod,
  UserRole,
  PaymentWidgetData
} from "../types";

// Mock payment data
export const mockPaymentData: PaymentData[] = [
  {
    id: "PAY001",
    paymentVoucherNumber: "PAY/2025/HYD/0041",
    paymentDate: "2025-08-08",
    paymentType: PaymentType.RA,
    contractorId: "CONT001",
    contractorName: "ABC Infra Ltd.",
    siteId: "SITE001",
    siteName: "Urban Rise - Tower A",
    projectId: "PROJ002",
    projectName: "Phase 2",
    legalEntityId: "LE001",
    legalEntityName: "URBAN RISE DEVELOPERS",
    paymentMethod: PaymentMethod.NEFT,
    bankAccountId: "BANK001",
    bankAccountName: "HDFC-0012",
    tdsSection: "194C",
    tdsRate: 1.0,
    narration: "Payment for RA bills Jul-2025",
    status: PaymentStatus.Paid,
    
    sumOfAllocations: 365320,
    tdsThisPayment: 7318,
    otherAdjustments: 0,
    netPayable: 358002,
    roundOff: 0,
    
    allocations: [
      {
        id: "ALLOC001",
        raBillId: "rab-001",
        raBillNumber: "RA/2025/URB/0007",
        workOrderId: "WO001",
        workOrderNumber: "WO/2025/URB/0012",
        raPeriod: "Jul-2025",
        raBillValue: 259120,
        alreadyPaid: 0,
        billBalance: 259120,
        thisPaymentAmount: 259120,
        resultingStatus: "Paid"
      },
      {
        id: "ALLOC002", 
        raBillId: "rab-002",
        raBillNumber: "RA/2025/URB/0008",
        workOrderId: "WO002",
        workOrderNumber: "WO/2025/URB/0015",
        raPeriod: "Jul-2025",
        raBillValue: 212400,
        alreadyPaid: 0,
        billBalance: 212400,
        thisPaymentAmount: 106200,
        resultingStatus: "Partially Paid"
      }
    ],
    
    deductions: [
      {
        id: "DED001",
        deductionType: "TDS",
        description: "TDS under section 194C",
        basis: "Pre-GST taxable base (pro-rated) × 1%",
        amount: 7318
      }
    ],
    
    financeDocNumber: "SAP-DOC-90811",
    utrReference: "HDFCNEFT/0908/123456",
    postedDate: "2025-08-08",
    postedBy: "finance.user@company.com",
    
    createdAt: "2025-08-05",
    createdBy: "maker@company.com",
    submittedAt: "2025-08-06",
    submittedBy: "maker@company.com",
    approvedAt: "2025-08-07",
    approvedBy: "approver@company.com",
    
    hasSoftHold: true,
    hasHardHold: false,
    
    attachments: [
      {
        id: "ATT001",
        fileName: "Payment Note.pdf",
        fileSize: 245760,
        fileType: "application/pdf",
        uploadDate: "2025-08-05",
        uploadedBy: "maker@company.com"
      }
    ],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker@company.com",
        actionDate: "2025-08-05T10:00:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Draft
      },
      {
        action: "Submitted for Approval",
        actionBy: "maker@company.com", 
        actionDate: "2025-08-06T09:30:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Submitted
      },
      {
        action: "Checked and Forwarded",
        actionBy: "checker@company.com",
        actionDate: "2025-08-06T14:15:00Z", 
        role: UserRole.Checker,
        comments: "Verified allocations and TDS calculations",
        status: PaymentStatus.Checked
      },
      {
        action: "Verified and Forwarded",
        actionBy: "verifier@company.com",
        actionDate: "2025-08-07T10:45:00Z",
        role: UserRole.Verifier,
        comments: "All documents and calculations verified",
        status: PaymentStatus.Verified
      },
      {
        action: "Approved",
        actionBy: "approver@company.com",
        actionDate: "2025-08-07T16:20:00Z",
        role: UserRole.Approver,
        comments: "Final approval granted",
        status: PaymentStatus.Approved
      },
      {
        action: "Posted to Finance",
        actionBy: "finance.user@company.com",
        actionDate: "2025-08-08T11:00:00Z",
        role: UserRole.Finance,
        comments: "Posted with UTR: HDFCNEFT/0908/123456",
        status: PaymentStatus.Posted
      }
    ]
  },
  
  {
    id: "PAY002",
    paymentVoucherNumber: "PAY/2025/HYD/0042", 
    paymentDate: "2025-08-10",
    paymentType: PaymentType.RA,
    contractorId: "CONT004",
    contractorName: "Galaxy Infra Private Limited",
    siteId: "SITE004",
    siteName: "Bangalore Complex",
    projectId: "PROJ003", 
    projectName: "Core & Shell",
    legalEntityId: "LE002",
    legalEntityName: "SOUTHERN DEVELOPMENTS",
    paymentMethod: PaymentMethod.RTGS,
    bankAccountId: "BANK002",
    bankAccountName: "ICICI-0031",
    tdsSection: "194C",
    tdsRate: 1.0,
    status: PaymentStatus.Submitted,
    
    sumOfAllocations: 550000,
    tdsThisPayment: 5500,
    otherAdjustments: 0,
    netPayable: 544500,
    
    allocations: [
      {
        id: "ALLOC003",
        raBillId: "rab-004",
        raBillNumber: "RA/2025/BLR/0010",
        workOrderId: "WO004",
        workOrderNumber: "WO/2025/BLR/0025",
        raPeriod: "Aug-2025",
        raBillValue: 550000,
        alreadyPaid: 0,
        billBalance: 550000,
        thisPaymentAmount: 550000,
        resultingStatus: "Paid"
      }
    ],
    
    deductions: [
      {
        id: "DED002",
        deductionType: "TDS",
        description: "TDS under section 194C",
        basis: "Pre-GST taxable base × 1%", 
        amount: 5500
      }
    ],
    
    createdAt: "2025-08-08",
    createdBy: "maker2@company.com",
    submittedAt: "2025-08-10",
    submittedBy: "maker2@company.com",
    
    hasSoftHold: false,
    hasHardHold: false,
    
    attachments: [],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker2@company.com",
        actionDate: "2025-08-08T15:30:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Draft
      },
      {
        action: "Submitted for Approval",
        actionBy: "maker2@company.com",
        actionDate: "2025-08-10T11:15:00Z", 
        role: UserRole.Maker,
        status: PaymentStatus.Submitted
      }
    ]
  },
  
  {
    id: "PAY003",
    paymentVoucherNumber: "PAY/2025/CHN/0043",
    paymentDate: "2025-08-12", 
    paymentType: PaymentType.RA,
    contractorId: "CONT005",
    contractorName: "Metro Builders & Engineers",
    siteId: "SITE005",
    siteName: "Chennai Metro Tower",
    projectId: "PROJ004",
    projectName: "Commercial Complex", 
    legalEntityId: "LE003",
    legalEntityName: "METRO REAL ESTATE",
    paymentMethod: PaymentMethod.NEFT,
    bankAccountId: "BANK001",
    bankAccountName: "HDFC-0012",
    tdsSection: "194C",
    tdsRate: 1.0,
    status: PaymentStatus.Checked,
    
    sumOfAllocations: 225000,
    tdsThisPayment: 2250,
    otherAdjustments: 0,
    netPayable: 222750,
    
    allocations: [
      {
        id: "ALLOC004",
        raBillId: "rab-005",
        raBillNumber: "RA/2025/CHN/0011",
        workOrderId: "WO005", 
        workOrderNumber: "WO/2025/CHN/0032",
        raPeriod: "Aug-2025",
        raBillValue: 425000,
        alreadyPaid: 200000,
        billBalance: 225000,
        thisPaymentAmount: 225000,
        resultingStatus: "Paid"
      }
    ],
    
    deductions: [
      {
        id: "DED003",
        deductionType: "TDS",
        description: "TDS under section 194C",
        basis: "Pre-GST taxable base × 1%",
        amount: 2250
      }
    ],
    
    createdAt: "2025-08-10",
    createdBy: "maker3@company.com",
    submittedAt: "2025-08-11",
    submittedBy: "maker3@company.com",
    
    hasSoftHold: false,
    hasHardHold: false,
    
    attachments: [],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker3@company.com",
        actionDate: "2025-08-10T09:00:00Z",
        role: UserRole.Maker, 
        status: PaymentStatus.Draft
      },
      {
        action: "Submitted for Approval",
        actionBy: "maker3@company.com",
        actionDate: "2025-08-11T14:30:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Submitted
      },
      {
        action: "Checked and Forwarded", 
        actionBy: "checker@company.com",
        actionDate: "2025-08-12T10:15:00Z",
        role: UserRole.Checker,
        comments: "Verified and forwarded to verifier",
        status: PaymentStatus.Checked
      }
    ]
  },
  
  // Additional payment records for comprehensive testing
  {
    id: "PAY004",
    paymentVoucherNumber: "PAY/2025/BLR/0044",
    paymentDate: "2025-08-15",
    paymentType: PaymentType.RA,
    contractorId: "CONT004",
    contractorName: "Galaxy Infra Private Limited",
    siteId: "SITE004",
    siteName: "Bangalore Complex", 
    projectId: "PROJ003",
    projectName: "Core & Shell",
    legalEntityId: "LE001",
    legalEntityName: "URBAN RISE DEVELOPERS",
    paymentMethod: PaymentMethod.NEFT,
    bankAccountId: "BANK002",
    bankAccountName: "ICICI-0031",
    tdsSection: "194C",
    tdsRate: 1.0,
    narration: "Payment for RA bills Aug-2025",
    status: PaymentStatus.Approved,
    
    sumOfAllocations: 550000,
    tdsThisPayment: 5500,
    otherAdjustments: 0,
    netPayable: 544500,
    roundOff: 0,
    
    allocations: [
      {
        id: "ALLOC005",
        raBillId: "rab-004",
        raBillNumber: "RA/2025/BLR/0010",
        workOrderId: "WO004",
        workOrderNumber: "WO/2025/BLR/0025",
        raPeriod: "Aug-2025",
        raBillValue: 550000,
        alreadyPaid: 0,
        billBalance: 550000,
        thisPaymentAmount: 550000,
        resultingStatus: "Paid"
      }
    ],
    
    deductions: [
      {
        id: "DED004",
        deductionType: "TDS",
        description: "TDS under section 194C",
        basis: "Pre-GST taxable base × 1%",
        amount: 5500
      }
    ],
    
    createdAt: "2025-08-13",
    createdBy: "maker4@company.com",
    submittedAt: "2025-08-14",
    submittedBy: "maker4@company.com",
    
    hasSoftHold: false,
    hasHardHold: false,
    
    attachments: [],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker4@company.com",
        actionDate: "2025-08-13T16:00:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Draft
      },
      {
        action: "Submitted for Approval",
        actionBy: "maker4@company.com",
        actionDate: "2025-08-14T10:30:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Submitted
      },
      {
        action: "Checked and Forwarded",
        actionBy: "checker@company.com",
        actionDate: "2025-08-14T14:15:00Z",
        role: UserRole.Checker,
        status: PaymentStatus.Checked
      },
      {
        action: "Verified and Forwarded",
        actionBy: "verifier@company.com",
        actionDate: "2025-08-15T09:45:00Z",
        role: UserRole.Verifier,
        status: PaymentStatus.Verified
      },
      {
        action: "Approved",
        actionBy: "approver@company.com",
        actionDate: "2025-08-15T11:30:00Z",
        role: UserRole.Approver,
        status: PaymentStatus.Approved
      }
    ]
  },
  
  {
    id: "PAY005",
    paymentVoucherNumber: "PAY/2025/DEL/0045",
    paymentDate: "2025-08-16",
    paymentType: PaymentType.SecurityDeposit,
    contractorId: "CONT006",
    contractorName: "Delhi Construction Co.",
    siteId: "SITE006",
    siteName: "Delhi Heights",
    projectId: "PROJ005",
    projectName: "Residential Towers",
    legalEntityId: "LE002",
    legalEntityName: "SOUTHERN DEVELOPMENTS",
    paymentMethod: PaymentMethod.NEFT,
    bankAccountId: "BANK003",
    bankAccountName: "SBI-0045",
    tdsSection: "194C",
    tdsRate: 1.0,
    narration: "Security Deposit Refund",
    status: PaymentStatus.Posted,
    
    sumOfAllocations: 200000,
    tdsThisPayment: 0,
    otherAdjustments: 0,
    netPayable: 200000,
    roundOff: 0,
    
    allocations: [
      {
        id: "ALLOC006",
        raBillId: "sd-refund-001",
        raBillNumber: "SD-REF/2025/DEL/001",
        workOrderId: "WO006",
        workOrderNumber: "WO/2025/DEL/0041",
        raPeriod: "Completion",
        raBillValue: 200000,
        alreadyPaid: 0,
        billBalance: 200000,
        thisPaymentAmount: 200000,
        resultingStatus: "Paid"
      }
    ],
    
    deductions: [],
    
    createdAt: "2025-08-14",
    createdBy: "maker5@company.com",
    submittedAt: "2025-08-15",
    submittedBy: "maker5@company.com",
    
    hasSoftHold: false,
    hasHardHold: false,
    
    attachments: [],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker5@company.com",
        actionDate: "2025-08-14T11:00:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Draft
      },
      {
        action: "Submitted for Approval",
        actionBy: "maker5@company.com",
        actionDate: "2025-08-15T13:45:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Submitted
      },
      {
        action: "Checked and Forwarded",
        actionBy: "checker@company.com",
        actionDate: "2025-08-15T15:20:00Z",
        role: UserRole.Checker,
        status: PaymentStatus.Checked
      },
      {
        action: "Verified and Forwarded",
        actionBy: "verifier@company.com",
        actionDate: "2025-08-16T08:30:00Z",
        role: UserRole.Verifier,
        status: PaymentStatus.Verified
      },
      {
        action: "Approved",
        actionBy: "approver@company.com",
        actionDate: "2025-08-16T10:15:00Z",
        role: UserRole.Approver,
        status: PaymentStatus.Approved
      },
      {
        action: "Posted",
        actionBy: "finance@company.com",
        actionDate: "2025-08-16T12:00:00Z",
        role: UserRole.Finance,
        status: PaymentStatus.Posted
      }
    ]
  },

  {
    id: "PAY006",
    paymentVoucherNumber: "PAY/2025/URB/0046",
    paymentDate: "2025-08-17",
    paymentType: PaymentType.RetentionRelease,
    contractorId: "CONT001",
    contractorName: "ABC Infra Ltd.",
    siteId: "SITE001",
    siteName: "Urban Rise - Tower A",
    projectId: "PROJ002",
    projectName: "Phase 2", 
    legalEntityId: "LE001",
    legalEntityName: "URBAN RISE DEVELOPERS",
    paymentMethod: PaymentMethod.NEFT,
    bankAccountId: "BANK001",
    bankAccountName: "HDFC-0012",
    tdsSection: "194C",
    tdsRate: 1.0,
    narration: "Retention Release Payment",
    status: PaymentStatus.Draft,
    
    sumOfAllocations: 75000,
    tdsThisPayment: 750,
    otherAdjustments: 0,
    netPayable: 74250,
    roundOff: 0,
    
    allocations: [
      {
        id: "ALLOC007",
        raBillId: "ret-rel-001",
        raBillNumber: "RET-REL/2025/URB/001",
        workOrderId: "WO001",
        workOrderNumber: "WO/2025/URB/0012",
        raPeriod: "Retention Release",
        raBillValue: 75000,
        alreadyPaid: 0,
        billBalance: 75000,
        thisPaymentAmount: 75000,
        resultingStatus: "Paid"
      }
    ],
    
    deductions: [
      {
        id: "DED005",
        deductionType: "TDS",
        description: "TDS under section 194C",
        basis: "Pre-GST taxable base × 1%",
        amount: 750
      }
    ],
    
    createdAt: "2025-08-17",
    createdBy: "maker6@company.com",
    
    hasSoftHold: false,
    hasHardHold: false,
    
    attachments: [],
    
    approvalHistory: [
      {
        action: "Created",
        actionBy: "maker6@company.com", 
        actionDate: "2025-08-17T14:30:00Z",
        role: UserRole.Maker,
        status: PaymentStatus.Draft
      }
    ]
  }
];

// Helper functions
export const getPaymentById = (id: string): PaymentData | null => {
  return mockPaymentData.find(payment => payment.id === id) || null;
};

export const getPaymentsByStatus = (status: PaymentStatus): PaymentData[] => {
  return mockPaymentData.filter(payment => payment.status === status);
};

export const getPaymentsByContractor = (contractorId: string): PaymentData[] => {
  return mockPaymentData.filter(payment => payment.contractorId === contractorId);
};

export const getPaymentsForApproval = (userRole: UserRole): PaymentData[] => {
  const roleStatusMapping: Partial<Record<UserRole, PaymentStatus>> = {
    [UserRole.Checker]: PaymentStatus.Submitted,
    [UserRole.Verifier]: PaymentStatus.Checked, 
    [UserRole.Approver]: PaymentStatus.Verified,
    [UserRole.Finance]: PaymentStatus.Approved
  };
  
  const targetStatus = roleStatusMapping[userRole];
  return targetStatus ? mockPaymentData.filter(payment => payment.status === targetStatus) : [];
};

// Widget data
export const mockPaymentWidgetData: PaymentWidgetData = {
  totalPayments: mockPaymentData.length,
  draftCount: mockPaymentData.filter(p => p.status === PaymentStatus.Draft).length,
  draftPercentage: 10,
  submittedCount: mockPaymentData.filter(p => p.status === PaymentStatus.Submitted).length,
  submittedPercentage: 20,
  approvedCount: mockPaymentData.filter(p => p.status === PaymentStatus.Approved).length,
  approvedPercentage: 30,
  postedCount: mockPaymentData.filter(p => p.status === PaymentStatus.Posted).length,
  postedPercentage: 25,
  paidCount: mockPaymentData.filter(p => p.status === PaymentStatus.Paid).length,
  paidPercentage: 15,
  totalPaymentValue: mockPaymentData.reduce((sum, p) => sum + p.netPayable, 0),
  avgPaymentValue: mockPaymentData.reduce((sum, p) => sum + p.netPayable, 0) / mockPaymentData.length,
  avgApprovalTime: 2.5
};

// Master data options
export const mockLegalEntityOptions = [
  { label: "URBAN RISE DEVELOPERS", value: "LE001" },
  { label: "SOUTHERN DEVELOPMENTS", value: "LE002" },
  { label: "METRO REAL ESTATE", value: "LE003" },
];

export const mockBankAccountOptions = [
  { label: "HDFC Bank - 0012", value: "BANK001", accountNumber: "50200012345678", bankName: "HDFC Bank" },
  { label: "ICICI Bank - 0031", value: "BANK002", accountNumber: "003187654321", bankName: "ICICI Bank" },
  { label: "SBI - 0045", value: "BANK003", accountNumber: "10234567890123", bankName: "State Bank of India" },
];

export const mockTdsSectionOptions = [
  { label: "194C - Payments to contractors", value: "194C", rate: 1.0 },
  { label: "194J - Professional fees", value: "194J", rate: 10.0 },
  { label: "194I - Rent", value: "194I", rate: 10.0 },
];

export const mockPaymentMethodOptions = [
  { label: "Cash", value: PaymentMethod.Cash },
  { label: "UPI", value: PaymentMethod.UPI },
  { label: "Cheque", value: PaymentMethod.Cheque },
  { label: "NEFT", value: PaymentMethod.NEFT },
  { label: "RTGS", value: PaymentMethod.RTGS },
  { label: "IMPS", value: PaymentMethod.IMPS },
];

export const mockPaymentStatusOptions = [
  { label: "Draft", value: PaymentStatus.Draft },
  { label: "Submitted", value: PaymentStatus.Submitted },
  { label: "Checked", value: PaymentStatus.Checked },
  { label: "Verified", value: PaymentStatus.Verified },
  { label: "Approved", value: PaymentStatus.Approved },
  { label: "Posted", value: PaymentStatus.Posted },
  { label: "Paid", value: PaymentStatus.Paid },
  { label: "Rejected", value: PaymentStatus.Rejected },
  { label: "Returned", value: PaymentStatus.Returned },
];

export const mockContractorOptions = [
  { label: "ABC Infra Ltd.", value: "CONT001" },
  { label: "XYZ Constructions", value: "CONT002" },
  { label: "BuildTech Pvt Ltd.", value: "CONT003" },
  { label: "Galaxy Infra Private Limited", value: "CONT004" },
  { label: "Metro Builders & Engineers", value: "CONT005" },
  { label: "Delhi Construction Co.", value: "CONT006" },
];

export const mockSiteOptions = [
  { label: "Urban Rise - Tower A", value: "SITE001" },
  { label: "Urban Rise - Tower B", value: "SITE002" }, 
  { label: "Urban Rise - Tower C", value: "SITE003" },
  { label: "Bangalore Complex", value: "SITE004" },
  { label: "Chennai Metro Tower", value: "SITE005" },
  { label: "Delhi Heights", value: "SITE006" },
];

export const mockProjectOptions = [
  { label: "Phase 1", value: "PROJ001" },
  { label: "Phase 2", value: "PROJ002" },
  { label: "Core & Shell", value: "PROJ003" },
  { label: "Commercial Complex", value: "PROJ004" },
  { label: "Residential Towers", value: "PROJ005" },
];